<template>
    <div class="progress-bar-track">
        <div class="progress-bar-fill" :style="{ width: percentage + '%' }"></div>
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',

    props: {
        totalValue: {
            type: Number,
            required: true,
        },
        currentValue: {
            type: Number,
            required: true,
        },
    },

    computed: {
        percentage() {
            if (!this.totalValue || this.totalValue <= 0) return 0;
            return Math.min(100, Math.max(0, (this.currentValue / this.totalValue) * 100));
        },
    },
};
</script>

<style scoped>
.progress-bar-track {
    width: 100%;
    height: 12px;
    background-color: #d9d9d9; /* grey */
    border-radius: 9999px;
    overflow: hidden;
}

.progress-bar-fill {
    height: 100%;
    background-color: #de9e52; /* orange */
    border-radius: 9999px;
    transition: width 0.3s ease;
}
</style>
